import configureStore from './config';

const store = configureStore();

export default store;
